<template>
    <div class="footer-nav">
        <nav>
            <ul>
                <li>
                    <router-link
                        :to="{name: 'home-books'}"
                        class="footer-nav__link"
                    >
                        <icon-book />

                        <span>Home</span>
                    </router-link>
                </li>

                <li>
                    <router-link
                        :to="{name: 'search'}"
                        class="footer-nav__link"
                    >
                        <icon-search />

                        <span>Cerca</span>
                    </router-link>
                </li>

                <li>
                    <router-link
                        :to="{name: 'bookmarks'}"
                        class="footer-nav__link"
                    >
                        <icon-bookmark />
                        <span>Letture</span>
                    </router-link>
                </li>

                <li>
                    <router-link
                        :to="{name: 'profile'}"
                        class="footer-nav__link"
                    >
                        <icon-profile />

                        <span>Profilo</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import IconBook from '@/components/icons/icon-book/icon-book';
import IconSearch from '@/components/icons/icon-search/icon-search';
import IconBookmark from '@/components/icons/icon-bookmark/icon-bookmark';
import IconProfile from '@/components/icons/icon-profile/icon-profile';

export default {
    name: 'FooterNavigation',

    components: {
        IconBook,
        IconSearch,
        IconBookmark,
        IconProfile,
    }
}
</script>
